export default "__VITE_ASSET__BdSEBSU8__"